import { Role } from "@/router/_helper";

  const classroom = {
    path: "/classroom",
    name: "classroom",
    component: () => import(/* webpackChunkName: "classroom" */ "@/components/classroom/ClassroomIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "classroom" */ "@/components/classroom/ClassroomView.vue"), name: "classroomView", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true }},
      { path: "edit/:id", component: () => import(/* webpackChunkName: "classroom" */ "@/components/classroom/ClassroomEdit.vue"), name: "classroomEdit", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true }},
      { path: "create", component: () => import(/* webpackChunkName: "classroom" */ "@/components/classroom/ClassroomCreate.vue"), name: "classroomCreate", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true }}
    ],
    meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true }
  };

export default classroom;
    